import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';

import { FieldType, FormlyModule } from '@ngx-formly/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormService } from '../../../features/admin/modules/features/form-builder/form.service';
import { debounceTime, takeUntil } from 'rxjs';
import { injectDestroy } from 'ngxtension/inject-destroy';
import { canMutateField } from './readonly/readonly.types';

@Component({
  selector: 'app-formly-form-builder',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormlyModule, FormsModule, ReactiveFormsModule],
  template: ``,
})
export class FormlyFormBuilderToGeneratedFormComponent extends FieldType implements OnInit {
  formService = inject(FormService);
  private destroy$ = injectDestroy();
  constructor() {
    super();
  }

  /**
   * Read-mode gate shared with the own-view family (`canMutateField`). This component has no
   * template: its only write is the programmatic `patchValue` below, and Angular does NOT refuse
   * `patchValue` on a disabled control — so the `props.disabled` stamp read mode applies gates
   * nothing here by itself. The gate has to be asked explicitly.
   */
  canMutate(): boolean {
    return canMutateField(this.field);
  }

  ngOnInit() {
    this.field.form.valueChanges.pipe(takeUntil(this.destroy$), debounceTime(500)).subscribe(() => {
      if (!this.canMutate()) {
        return;
      }
      const generatedForm = this.formService.generateForm(this.model['form']);
      if (JSON.stringify(this.field.formControl.value) != JSON.stringify(generatedForm)) {
        this.field.formControl.patchValue(generatedForm);
      }
    });
  }
}
